var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "181px",
    height: "159px",
    viewBox: "0 0 181 159",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 175.438596,
    height: 130.395349,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: -4.12114787e-13,
    y: 4.8316906e-13,
    width: 17.5438596,
    height: 37.3604651,
    rx: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.0%",
    y: "-9.4%",
    width: "139.9%",
    height: "118.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 0.177368923,
    y: 0.554809729,
    width: 22.6608187,
    height: 52.744186
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 0,
    y: 0,
    width: 175.438596,
    height: 21.9767442,
    rx: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.4%",
    y: "-11.4%",
    width: "102.8%",
    height: "122.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home_Error",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-622.000000, -191.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(595.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Not-found---404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Not-found",
    transform: "translate(27.046784, 21.976744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1547"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#D9D9D9",
    strokeWidth: 3,
    x: 1.5,
    y: 1.5,
    width: 172.438596,
    height: 127.395349,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(126.845853, 105.506779) scale(-1, 1) rotate(-315.000000) translate(-126.845853, -105.506779) translate(90.296145, 41.041662)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-453",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 32.1637427,
    y: 70.3255814,
    width: 8.77192982,
    height: 54.2093023,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(27.046784, 91.517706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-453"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F6F6F6",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#D9D9D9",
    strokeWidth: 3,
    xlinkHref: "#path-2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.5497076,73.255814 C16.3638615,73.255814 -6.82121026e-13,56.8569414 -6.82121026e-13,36.627907 C-6.82121026e-13,16.3988725 16.3638615,5.68434189e-13 36.5497076,5.68434189e-13 C56.7355537,5.68434189e-13 73.0994152,16.3988725 73.0994152,36.627907 C73.0994152,56.8569414 56.7355537,73.255814 36.5497076,73.255814 Z M36.5497076,65.9302326 C52.6983845,65.9302326 65.7894737,52.8111345 65.7894737,36.627907 C65.7894737,20.4446794 52.6983845,7.3255814 36.5497076,7.3255814 C20.4010307,7.3255814 7.30994152,20.4446794 7.30994152,36.627907 C7.30994152,52.8111345 20.4010307,65.9302326 36.5497076,65.9302326 Z",
    id: "Combined-Shape",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5497076,65.9302326 C52.6983845,65.9302326 65.7894737,52.8111345 65.7894737,36.627907 C65.7894737,20.4446794 52.6983845,7.3255814 36.5497076,7.3255814 C20.4010307,7.3255814 7.30994152,20.4446794 7.30994152,36.627907 C7.30994152,52.8111345 20.4010307,65.9302326 36.5497076,65.9302326 Z",
    id: "Oval-76",
    stroke: "#EEEDED",
    strokeWidth: 3,
    fillOpacity: 0.2,
    fill: "#60BBDA",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(10.536706, 1.161681)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8816781,55.0459831 C38.782035,55.0459831 47.6185202,46.1905919 47.6185202,35.2669133 C47.6185202,24.3432347 38.782035,15.4878435 27.8816781,15.4878435 C16.9813212,15.4878435 8.14483598,24.3432347 8.14483598,35.2669133 C8.14483598,46.1905919 16.9813212,55.0459831 27.8816781,55.0459831 Z",
    id: "Oval-76",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: 25,
    mask: "url(#mask-5)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-80",
    fill: "#FFFFFF",
    cx: 30.5243855,
    cy: 54.6384249,
    rx: 2.19298246,
    ry: 2.19767442
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1547"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#D9D9D9",
    strokeWidth: 3,
    x: 1.5,
    y: 1.5,
    width: 172.438596,
    height: 18.9767442,
    rx: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-69",
    fill: "#D9D9D9",
    cx: 10.9649123,
    cy: 10.9883721,
    rx: 2.92397661,
    ry: 2.93023256
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-69",
    fill: "#D9D9D9",
    cx: 21.1988304,
    cy: 10.9883721,
    rx: 2.92397661,
    ry: 2.93023256
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-69",
    fill: "#D9D9D9",
    cx: 31.4327485,
    cy: 10.9883721,
    rx: 2.92397661,
    ry: 2.93023256
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-Copy",
    opacity: 0.5,
    transform: "translate(40.935673, 52.631579)",
    fill: "#838383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.467880)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.336028938,
    y: 0.421092264,
    width: 4.8004134,
    height: 8.56220936
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 7.72866558,
    y: 0.421092264,
    width: 8.83276066,
    height: 8.60899739
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "20.1617363 9.03008966 20.1617363 37.1964833 31.0586747 37.1964833 31.0586747 9.03008966 37.3472163 9.03008966 37.3472163 0.421092264 20.1617363 0.421092264"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 39.8914354,
    y: 0.421092264,
    width: 3.64831419,
    height: 8.60899739
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.53fd28c41c4ee0edf3acf332054b9df2.svg";
export { ForwardRef as ReactComponent };